<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.9857 15.9999L4 15.0142L9.0143 9.99991L4 4.9856L4.9857 3.99991L10 9.01421L15.0143 3.99991L16 4.9856L10.9857 9.99991L16 15.0142L15.0143 15.9999L10 10.9856L4.9857 15.9999Z" fill="#FF3B30"/>
  </svg>
</template>